import React from 'react';
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';

import {CardContainer, Tab, Loading, Notification} from 'components/common/uiKit';

import * as RouteService from 'services/route';
import {Info, Lessons, Levels} from "./tabs";


const TabsData = [
    {
        key: 'Info',
        title: '',
        component: Info,
    },
    {
        key: 'Lessons',
        title: '',
        component: Lessons,
    },
    {
        key: 'Levels',
        title: '',
        component: Levels,
    }
];


class CourseDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            courseId: 0,
            data: [],
            loading: true,
            selectedTab: 0
        };
    };

    componentDidMount() {
        let courseId = 0;

        const qs = RouteService.QueryStringService.getQyeryStrings();

        if (!qs || !qs.courseId) {
            Notification('error', 'WrongData');

            const {history} = this.props;
            history.replace({
                pathname: 'admin/main'
            });
        }

        courseId = qs.courseId;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.Course.Tabs;

        let _tabsData = TabsData.map(x => {
            x.title = pageTranslates[x.key];
            return Object.assign(x, {params: {courseId}});
        });
        this.setState({data: _tabsData, courseId});

        this.handleActiveTab();

        this.setState({loading: false});
    }

    handleActiveTab() {
        //TODO: should config
        const {router} = this.props;
        const pushedRoute = router.filter(x => x.action.toLowerCase() == 'push');
        if (pushedRoute && pushedRoute.length > 0) {
            let last = pushedRoute.sort((a, b) => b.id - a.id)[0].location.pathname;
            if(last.includes('imageSlide'))
                last = pushedRoute.sort((a, b) => b.id - a.id)[1].location.pathname;

            if (last.includes('lesson')) {
                this.setState({selectedTab: 1});
            }
            if (last.includes('level')) {
                this.setState({selectedTab: 2});
            }
        }
    }

    render() {
        const {data, loading, selectedTab} = this.state;

        if (loading) return <Loading/>;

        return (
            <div>
                <Tab value={selectedTab} data={data}/>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {locale, router} = state;
    return {locale, router};
};

export default connect(mapStateToProps, null)(withRouter(CourseDetail));
